import { useMutation, useQueryClient } from "react-query";

import axios from "axios";
import { AUTOMATION_SERVICE_ADDRESS } from "constants/app.constants";

import { AUTOMATION_COLLECTIONS_QUERY_KEY } from "./useFetchAutomationCollections";

const deleteAutomationCollection = async (id: string) => {
  // Adjust the endpoint as needed
  const response = await axios.delete(`${AUTOMATION_SERVICE_ADDRESS}/automation/${id}`);
  return response.data;
};

export default function useDeleteAutomationCollection() {
  const queryClient = useQueryClient();
  return useMutation(deleteAutomationCollection, {
    onSuccess: () => {
      queryClient.invalidateQueries(AUTOMATION_COLLECTIONS_QUERY_KEY);
    }
  });
}
